<ng-container *transloco="let t">
  <label class="form-label mb-2" [ngClass]="{'required': required}">{{ label }}</label>
  @if (liens.length === 0) {
    @if (reo.amountOfMortgage) {
      <div class="text-muted fs-7 mb-3">{{ t('wizard.reo.lienBalanceOnFile', { amount: (reo.amountOfMortgage | currency) }) }}</div>
    } @else {
      <div class="text-muted fs-7 mb-3">{{ t('wizard.reo.noLiensYet') }}</div>
    }
  } @else {
    <div class="table-responsive mb-3">
      <table class="table table-row-dashed align-middle gs-0 gy-2 mb-0">
        <thead>
          <tr class="fw-bold text-muted fs-7">
            <th>{{ t('wizard.reo.lienPosition') }}</th>
            <th>{{ t('wizard.reo.lienHolder') }}</th>
            <th>{{ t('wizard.reo.lienAccountNumber') }}</th>
            <th class="text-end">{{ t('wizard.reo.lienBalance') }}</th>
            <th>{{ t('wizard.assets.owners') }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (lien of liens; track lien.liabilityId) {
            <tr>
              <td>{{ positionName(lien) }}</td>
              <td>{{ lien.holderName }}</td>
              <td>{{ maskedAccount(lien) }}</td>
              <td class="text-end">{{ lien.unpaidBalance | currency }}</td>
              <td>{{ ownerNames(lien) }}</td>
              <td class="text-end text-nowrap">
                @if (!lien.fromCreditReport) {
                  <button type="button" class="btn btn-sm btn-icon btn-light-primary me-2" [title]="t('wizard.reo.editLien')" (click)="onEditClicked(lien)">
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-icon btn-light-danger" [title]="t('wizard.reo.deleteLien')" (click)="onDeleteClicked(lien)">
                    <i class="fas fa-trash"></i>
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <button type="button" class="btn btn-sm btn-light-primary" (click)="onAddClicked()">
    <i class="fas fa-plus"></i> {{ t('wizard.reo.addExistingLien') }}
  </button>
  @if (showRequiredError) {
    <div class="text-danger fs-7 mt-2">{{ t('wizard.reo.atLeastOneLienRequired') }}</div>
  }
</ng-container>
